import { ApolloClient, InMemoryCache, gql, createHttpLink } from "@apollo/client";
import { setContext } from '@apollo/client/link/context';

const httpLink = createHttpLink({
  uri: process.env.NODE_ENV === "development" ? "http://localhost:4000/graphql/" : 'https://api.beatmatch.xyz/graphql',
});

const authLink = setContext((_, { headers }) => {
  const token = localStorage.getItem('accessToken');
  return {
    headers: {
      ...headers,
      authorization: token ? `Bearer ${token}` : "",
    }
  }
});

const apolloClient = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache()
});

const BeatmatchBackendClient = {
  getTrack: async function (trackId) {
    const response = await apolloClient
      .query({
        query: gql`
          query GetTrack($trackId: ID!) {
            track(id: $trackId) {
              id,
              bpm,
              key,
              waveformLink
            }
          }
        `,
        variables: {
          trackId: trackId
        }
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    return response.data;
  },
  signUp: async function (email, password, firstName, lastName) {
    const response = await apolloClient
      .mutate({
        mutation: gql`
          mutation Signup($request: SignupInput!) {
            signup(request: $request) {
              accessToken
            }
          }
        `,
        variables: {
          request: {
            email: email,
            password: password,
            firstName: firstName,
            lastName: lastName,
          }
        }
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    console.log(JSON.stringify(response.data));
    return response.data;
  },
  login: async function (email, password) {
    const response = await apolloClient
      .mutate({
        mutation: gql`
        mutation Login($request: LoginInput!) {
          login(request: $request) {
            accessToken
          }
        }
      `,
        variables: {
          request: {
            email: email,
            password: password,
          }
        }
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    console.log(JSON.stringify(response.data));
    return response.data;
  },
  logout: async function () {
    const response = await apolloClient
      .mutate({
        mutation: gql`
        mutation Logout {
          logout {
            success
          }
        }
      `,
        variables: {}
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    console.log(JSON.stringify(response.data));
    return response.data;
  },
  refreshToken: async function () {
    const response = await apolloClient
      .mutate({
        mutation: gql`
        mutation RefreshToken {
          refreshToken {
            accessToken
          }
        }
      `,
        variables: {}
      });

    return response;
  },
  getUser: async function () {
    const response = await apolloClient
      .query({
        query: gql`
        query GetUser {
          user {
            id
            email
            firstName
            lastName
          }
        }
      `,
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    return response.data;
  },
  createPlaylist: async function (name, description) {
    const response = await apolloClient
      .mutate({
        mutation: gql`
        mutation createPlaylist($request: CreatePlaylistInput!) {
          createPlaylist(request: $request) {
            description
            id
            name
            owner {
              email
              firstName
              id
              lastName
            }
            tracks {
              id
              streamLink
              title
              artist
              artworkLink
              bpm
              duration
              genre
              mood
              key
            }
            version
          }
        }
      `,
        variables: {
          request: {
            description: description,
            name: name
          }
        }
      });

    if (response.errors) {
      console.error(JSON.stringify(response.errors));
    }

    return response.data.createPlaylist;
  }
}

export default BeatmatchBackendClient;